import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgClass, NgForOf } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService, Notification } from '../../services/notification.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [NgClass, NgForOf],
  template: `
    <div class="notification-container">
      <div *ngFor="let notification of notifications"
           class="alert alert-dismissible fade show"
           [ngClass]="'alert-' + notification.type">
        <span [innerHTML]="notification.message"></span>
        <button type="button" class="btn-close" (click)="removeNotification(notification)"></button>
      </div>
    </div>
  `,
  styles: [`
    .notification-container {
      position: fixed;
      top: 10px;
      right: 10px;
      z-index: 1050;
      max-width: 350px;
    }

    .alert {
      margin-bottom: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      animation: slideIn 0.3s ease-out;
    }

    @keyframes slideIn {
      0% {
        transform: translateX(100%);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `]
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private subscription?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.onNotification()
      .subscribe(notifications => {
        this.notifications = notifications;
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  removeNotification(notification: Notification): void {
    this.notificationService.clear(notification.id);
  }
}
